import _ from 'lodash'

import {
    NEGATIVE_EVENTS_LOAD_TABLE_DATA,
    NEGATIVE_EVENTS_TABLE_CHANGE,
    NEGATIVE_EVENTS_LOAD_TABLE_DATA_REQUEST,
    NEGATIVE_EVENTS_TABLE_LOADING_TRUE,
    NEGATIVE_EVENTS_TABLE_LOADING_FALSE,
    NEGATIVE_EVENTS_TABLE_DATA_RECEIVED,
    NEGATIVE_EVENTS_LOAD_EVENT_DETAIL,
    NEGATIVE_EVENTS_LOAD_EVENT_DETAIL_REQUEST,
    NEGATIVE_EVENTS_LOAD_EVENT_DETAIL_RECEIVED,
    NEGATIVE_EVENTS_LOAD_DISTRAINTS_HISTORY,
    NEGATIVE_EVENTS_LOAD_DISTRAINTS_HISTORY_REQUEST,
} from './constants'

import config from '../../../../../../../../../config'

export function negativeEventsLoadDistraintsHistory(id, module, block) {
    return {
        type: NEGATIVE_EVENTS_LOAD_DISTRAINTS_HISTORY,
        data: {
            id,
            module,
            block,
        },
    }
}

export function negativeEventsLoadDistraintsHistoryRequest() {
    return {
        type: NEGATIVE_EVENTS_LOAD_DISTRAINTS_HISTORY_REQUEST,
        payload: {
            uri: config.api.distraintsHistory.uri,
        },
    }
}

export function negativeEventsLoadTableData(tableId, tableSelector, entId, module, block, level, customData) {
    return {
        type: NEGATIVE_EVENTS_LOAD_TABLE_DATA,
        data: {
            tableId,
            tableSelector,
            entId,
            module,
            block,
            level,
            customData,
        },
    }
}

export function negativeEventsTableChange(
    tableId,
    tableSelector,
    entId,
    module,
    block,
    level,
    customData,
    queryParams
) {
    return {
        type: NEGATIVE_EVENTS_TABLE_CHANGE,
        data: {
            tableId,
            tableSelector,
            entId,
            module,
            block,
            level,
            customData,
            queryParams,
        },
    }
}

export function negativeEventsLoadTableDataRequest(
    tableId,
    tableSelector,
    entId,
    module,
    block,
    level,
    lang,
    token,
    queryParams
) {
    return {
        type: NEGATIVE_EVENTS_LOAD_TABLE_DATA_REQUEST(tableId),
        payload: {
            uri: _.get(config, `api.${module}.${block}.tables.${tableSelector}.uri`),
            qs: {
                ...queryParams,
                entId,
                lang,
                token,
                level,
            },
            uriParams: {
                entId,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function negativeEventsTableDataReceived(module, id, block, customData) {
    return {
        type: NEGATIVE_EVENTS_TABLE_DATA_RECEIVED,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}

export function negativeEventsTableLoadingTrue(module, block, id, customData) {
    return {
        type: NEGATIVE_EVENTS_TABLE_LOADING_TRUE,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}

export function negativeEventsTableLoadingFalse(module, block, id, customData) {
    return {
        type: NEGATIVE_EVENTS_TABLE_LOADING_FALSE,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}

export function negativeEventsLoadEventDetail({ module, block, entId, docId, level }) {
    return {
        type: NEGATIVE_EVENTS_LOAD_EVENT_DETAIL,
        payload: {
            module,
            block,
            entId,
            docId,
            level,
        },
    }
}

export function negativeEventsLoadEventDetailRequest({ entId, docId, token, level, block, module }) {
    return {
        type: NEGATIVE_EVENTS_LOAD_EVENT_DETAIL_REQUEST,
        payload: {
            uri: _.get(config, `api.${module}.${block}.details.insolvency.event.uri`),
            qs: {
                token,
                level,
            },
            uriParams: {
                entId,
                docId,
            },
        },
    }
}

export function negativeEventsLoadEventDetailReceived({ module, block, entId, customData }) {
    return {
        type: NEGATIVE_EVENTS_LOAD_EVENT_DETAIL_RECEIVED,
        data: {
            module,
            block,
            id: entId,
            customData,
        },
    }
}
